<template>
	<AsiCardDetail :title="$t('customer.defaultPaymentType')" :icon="icons.paymentType"
	               :show-action-button="!readonly" @actionButtonClicked="updateDialog.open()">
		<AsiCardDetailEntry :icon="icons.paymentType" :label="$t('customer.defaultPaymentType')"
		                    :value="defaultPaymentTypeNameTranslated" />

		<CustomerUpdateDefaultPaymentTypeDialog v-if="!readonly && updateDialog.isLoaded" :open="updateDialog.isOpen"
		                                         :customer="customer" @cancel="updateDialog.close()"
		                                         @save="updateDialog.close(); change();" />
	</AsiCardDetail>
</template>

<script lang="ts">
	import {Vue, Component, Prop, Emit} from 'vue-property-decorator';
	import AsiCardDetail from "@/components/common/AsiCardDetail.vue";
	import AsiCardDetailEntry from "@/components/common/AsiCardDetailEntry.vue";
	import {ICustomerShop} from "@/models/customer/CustomerShopModels";
	import {ICustomerAdmin} from "@/models/customer/CustomerAdminModels";
	import DialogHandler from "@/components/common/DialogHandler";
	import Icon from "@/plugins/icons";
	import TranslatedValueHelper from "@/models/translated-value/TranslatedValueHelper";
	import CustomerUpdateDefaultPaymentTypeDialog
		from "@/components/customer/shop/CustomerUpdateDefaultPaymentTypeDialog.vue";

	@Component({
		components: {CustomerUpdateDefaultPaymentTypeDialog, AsiCardDetailEntry, AsiCardDetail}
	})
	export default class CustomerCardDefaultPaymentType extends Vue {
		@Prop({type: Object, required: true})
		public customer!: ICustomerShop

		@Prop({type: Boolean, default: false})
		public readonly!: boolean;

		private updateDialog: DialogHandler = new DialogHandler();
		private icons = Icon;

		private get defaultPaymentTypeNameTranslated(): string | null {
			if (this.customer.defaultPaymentType?.name){
				return TranslatedValueHelper.get(this.customer.defaultPaymentType.name, this.$i18n.locale);
			}
			return null;
		}

		@Emit('change')
		public change(): void {
			return;
		}
	}
</script>

<style scoped lang="scss">

</style>
